export enum UserRole {
  LOGGED_OUT,
  CLIENT_ADMIN,
  HOLISTIC_ADMIN,
}

export interface CurrentUser {
  clientId?: string;
  role: UserRole;
}
export interface UserService {
  resolve(): Promise<CurrentUser>;
}
